let currentBlobUrl: string | null = null;

export function revokeCurrentBlobUrl() {
  if (currentBlobUrl) {
    URL.revokeObjectURL(currentBlobUrl);
    currentBlobUrl = null;
  }
}

export function registerBlobUrl(blobUrl: string): string {
  revokeCurrentBlobUrl();
  currentBlobUrl = blobUrl;
  return blobUrl;
}

export function isManagedBlobUrl(url: string): boolean {
  return url.startsWith("blob:") && url === currentBlobUrl;
}
